export default function setCommonFieldsForCurrentUser({ state }) {
  let { registrating, currentUser } = state.get('client')
  if (currentUser) {
    let common = registrating.current.common
    let aggregations = currentUser.currentClient.aggregations
    let commonPath = 'client.registrating.current.common'
    if (aggregations) {
      Object.keys(common).forEach(field => {
        let fieldInCommon = registrating.current.common[field]
        let fieldInCurrentClient = aggregations[field]
        let newData = null
        if (
          fieldInCurrentClient &&
          fieldInCommon &&
          fieldInCommon.aggregation
        ) {
          // if the aggregation is a select it's saved as an array
          if (Array.isArray(fieldInCurrentClient) && fieldInCommon.options) {
            newData = fieldInCommon.options.reduce((acc, item) => {
              if (fieldInCurrentClient.indexOf(item.key) > -1) {
                const { key, value, index, i18nKey } = item
                state.merge(`${commonPath}.${field}.options.${index}`, {
                  selected: true
                })
                acc.push({ key, value, index, i18nKey })
              }
              return acc
            }, [])
          }
          // normal input
          if (typeof fieldInCurrentClient === 'string') {
            newData = fieldInCurrentClient
            if (fieldInCommon.options) {
              newData = [] // sometimes the data is wrong in database because someone changed type restore
            }
            if (fieldInCommon.type === 'file') {
              newData = '' // wrong data
            }
          }
          // file
          if (fieldInCurrentClient.url) {
            newData = { ...fieldInCurrentClient, uploadDone: true }
          }
          state.set(`${commonPath}.${field}.value`, newData)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/actions/setAggregationFieldsForCurrentUser.js